import { put, takeLeading } from 'redux-saga/effects';

import bankingApi from 'api/bankingApi';

import { apiErrorHandler, showSuccess } from 'utils';

import { GET_PLACE_DETAIL } from 'store/place/actionTypes';
import {
// GET BANKING LIST
  GET_BANKING_LIST,
  GET_BANKING_LIST_SUCCESS,
  GET_BANKING_LIST_FAILED,

  // ADD BANKING OF PLACE
  ADD_BANKING_OF_PLACE,
  ADD_BANKING_OF_PLACE_SUCCESS,
  ADD_BANKING_OF_PLACE_FAILED,

  // UPDATE BANKING OF PLACE
  UPDATE_BANKING_OF_PLACE,
  UPDATE_BANKING_OF_PLACE_SUCCESS,
  UPDATE_BANKING_OF_PLACE_FAILED,

  // REQUEST UPDATE BANKING OF PLACE
  REQUEST_UPDATE_BANKING_OF_PLACE,
  REQUEST_UPDATE_BANKING_OF_PLACE_SUCCESS,
  REQUEST_UPDATE_BANKING_OF_PLACE_FAILED,
} from './actionTypes';

function* getBankingList({ payload }) {
  try {
    const { q, callback } = payload;
    const response = yield bankingApi.getBankingList({ q });

    yield put({
      type: GET_BANKING_LIST_SUCCESS,
      payload: response.payload,
    });

    callback?.(response.payload.data.map((item) => ({
      label: item.vnName,
      value: item.bankId,
    })));
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_BANKING_LIST_FAILED,
    });
  }
}

function* addBankingOfPlace({ payload }) {
  try {
    const { placeId, data, callback } = payload;
    yield bankingApi.addBankingOfPlace({
      placeId,
      data,
    });

    yield put({
      type: ADD_BANKING_OF_PLACE_SUCCESS,
    });

    yield put({
      type: GET_PLACE_DETAIL,
      payload: {
        placeId,
      },
    });

    showSuccess('Thêm tài khoản ngân hàng thành công');

    callback();
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: ADD_BANKING_OF_PLACE_FAILED,
    });
  }
}

function* updateBankingOfPlace({ payload }) {
  try {
    const {
      placeId, bankAccount, data, callback,
    } = payload;
    yield bankingApi.updateBankingOfPlace({
      placeId,
      bankAccount,
      data,
    });

    yield put({
      type: UPDATE_BANKING_OF_PLACE_SUCCESS,
    });

    yield put({
      type: GET_PLACE_DETAIL,
      payload: {
        placeId,
      },
    });

    showSuccess('Cập nhật tài khoản ngân hàng thành công');

    callback();
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: UPDATE_BANKING_OF_PLACE_FAILED,
    });
  }
}

function* requestUpdateBankingOfPlace({ payload }) {
  try {
    const { data, callback } = payload;
    yield bankingApi.requestUpdateBankingOfPlace(data);

    yield put({
      type: REQUEST_UPDATE_BANKING_OF_PLACE_SUCCESS,
    });

    showSuccess('Gửi yêu cầu chỉnh sửa tài khoản ngân hàng thành công');

    callback();
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: REQUEST_UPDATE_BANKING_OF_PLACE_FAILED,
    });
  }
}

export default function* bankingSaga() {
  yield takeLeading(GET_BANKING_LIST, getBankingList);
  yield takeLeading(ADD_BANKING_OF_PLACE, addBankingOfPlace);
  yield takeLeading(UPDATE_BANKING_OF_PLACE, updateBankingOfPlace);
  yield takeLeading(
    REQUEST_UPDATE_BANKING_OF_PLACE,
    requestUpdateBankingOfPlace,
  );
}
